module.exports = __webpack_public_path__ + "img/warranty.65ebb6e5.svg";